import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import ChatbotBuilder from './pages/ChatbotBuilder';
import ChatbotView from './pages/ChatbotView';
import KnowledgeBase from './pages/KnowledgeBase';
import PublicChat from './pages/PublicChat';
import ChatWidget from './pages/ChatWidget';
import Admin from './pages/Admin';
import Integrations from './pages/Integrations';
import Landing from './pages/Landing';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import DataDeletion from './pages/DataDeletion';
import { AuthProvider, useAuth } from './context/AuthContext';
import './App.css';

function PrivateRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="loading">Loading...</div>;
  return user ? children : <Navigate to="/login" />;
}

function HomeRoute() {
  const { user, loading } = useAuth();
  if (loading) return <div className="loading">Loading...</div>;
  return user ? <Navigate to="/dashboard" /> : <Landing />;
}

function AdminRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="loading">Loading...</div>;
  if (!user) return <Navigate to="/login" />;
  return user.is_admin ? children : <Navigate to="/dashboard" />;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route
        path="/dashboard"
        element={
          <PrivateRoute>
            <Dashboard />
          </PrivateRoute>
        }
      />
      <Route
        path="/builder"
        element={
          <PrivateRoute>
            <ChatbotBuilder />
          </PrivateRoute>
        }
      />
      <Route
        path="/builder/:id"
        element={
          <PrivateRoute>
            <ChatbotBuilder />
          </PrivateRoute>
        }
      />
      <Route
        path="/chatbot/:id"
        element={
          <PrivateRoute>
            <ChatbotView />
          </PrivateRoute>
        }
      />
      <Route
        path="/knowledge/:id"
        element={
          <PrivateRoute>
            <KnowledgeBase />
          </PrivateRoute>
        }
      />
      <Route
        path="/integrations/:id"
        element={
          <PrivateRoute>
            <Integrations />
          </PrivateRoute>
        }
      />
      <Route path="/chat/:id" element={<PublicChat />} />
      <Route path="/chat/:id/:slug" element={<PublicChat />} />
      <Route path="/widget/:id" element={<ChatWidget />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/data-deletion" element={<DataDeletion />} />
      <Route
        path="/admin"
        element={
          <AdminRoute>
            <Admin />
          </AdminRoute>
        }
      />
      <Route path="/" element={<HomeRoute />} />
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Toaster position="top-right" />
          <AppRoutes />
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;



